import { AlloyButton, Popup } from 'cat-ecommerce-alloy';
import ContactDealerPopup from '../ContactDealerPopup';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const ContactDealerButtonPopup = ({
  buttonLabel,
  buttonType = 'secondary',
  className,
  catEntryId
}) => {
  const [t] = useTranslation();

  const getDealerInitiator = contactButtonLabel => (
    <AlloyButton buttonType={buttonType} className={className}>
      {contactButtonLabel || t('CONTACT_YOUR_DEALER')}
    </AlloyButton>
  );
  const popperOptions = {
    placement: 'bottom'
  };
  return (
    <Popup
      contents={<ContactDealerPopup catEntryId={catEntryId} />}
      initiator={getDealerInitiator(buttonLabel)}
      popperOptions={popperOptions}
    />
  );
};

export default ContactDealerButtonPopup;

ContactDealerButtonPopup.propTypes = {
  buttonLabel: PropTypes.string,
  buttonType: PropTypes.string,
  className: PropTypes.string,
  catEntryId: PropTypes.string
};
